import React from 'react';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import CancelIcon from '@material-ui/icons/Cancel';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  green: {
    color: green['500']
  },
  red: {
    color: red['500']
  }
});

const TargetMarketIcon = ({ classes, inTarget }) => {
  const text = inTarget ? 'In Target Market' : 'Off Target Market';
  const icon = inTarget ? (
    <CheckCircleIcon className={classes.green} />
  ) : (
    <CancelIcon className={classes.red} />
  );
  return (
    <div className={classes.root}>
      <Typography variant="caption">{icon}</Typography>
      <Typography variant="caption">{text}</Typography>
    </div>
  );
};

export default withStyles(styles)(TargetMarketIcon);